import { useState, useEffect } from "react";
import "./modalproductdetail.css";
import { useProductStore } from "@/_zustand/store";
import { useMachine } from "@/_zustand/machine";
import { RedTag } from "../components/RedTag";
import { BlueTag } from "./BlueTag";
import { OfferTag } from "../components/OfferTag";
import { formatMoney } from "@/lib";
import { resolverPrecioProducto, resolverBadgesDescuento } from "@/lib/precioProducto";
import { ModalStoreCart } from "./ModalStoreCart";

export const ModalProductDetail = ({ product, show, handleClose }) => {
  const [quantity, setQuantity] = useState(1);
  const [showModalStoreCart, setShowModalStoreCart] = useState(false);
  const { machineSelected, logoMachine, addressMachine, nameEmpresa } =
    useMachine();
  const { addToCart, calculateTotals, setStoreToPay } = useProductStore();

  // Resetear la cantidad a 1 cuando el producto cambia (ej. se abre el modal para otro producto)
  useEffect(() => {
    setQuantity(1);
  }, [product]);

  // Función para disminuir la cantidad
  const decrease = () => {
    setQuantity((prevQuantity) => Math.max(1, prevQuantity - 1)); // La cantidad mínima es 1
  };

  // Función para aumentar la cantidad
  const increase = () => {
    setQuantity((prevQuantity) => prevQuantity + 1);
  };

  const handleAddToCart = (product) => {
    const finalQuantity = Math.max(1, Number(quantity) || 1);

    let dataToAdd = {
      ...product,
      producto_cant: finalQuantity,
      maquina_id: machineSelected,
      logo_machine: logoMachine,
      address_machine: addressMachine,
      name_empresa: nameEmpresa,
    };
    addToCart(dataToAdd, machineSelected);
    setStoreToPay(machineSelected);
    calculateTotals(machineSelected);

    setShowModalStoreCart(true);

    //return navigate(`/store/${machineSelected}`, { replace: true });
  };

  if (show) {
    const { precioFinal, precioOriginal, tieneDescuento } =
      resolverPrecioProducto(product);
    const badges = resolverBadgesDescuento(product);
    return (
      <div className="detail-producto-overlay">
        <ModalStoreCart
          isOpen={showModalStoreCart}
          onClose={() => setShowModalStoreCart(false)}
        />
        <div className="detail-producto-container">
          <button type="button" className="close" onClick={handleClose}>
            &times;
          </button>

          <div className="detail-producto-image-wrapper">
            <img
              src={product.producto_foto}
              alt={product.producto_nombre}
              className="detail-producto-image"
            />
            <i className="fav-heart" />
          </div>

          <div className="detail-producto-info">
            <h2 className="detail-producto-title">{product.producto_nombre}</h2>

            <div className="detail-producto-price-wrapper">
              <span className="detail-producto-price">
                {formatMoney(precioFinal)} CLP
              </span>
              {badges.map((badge, i) =>
                badge.tipo === "porcentaje" ||
                badge.tipo === "porcentaje-oferta" ? (
                  <RedTag key={i} percentage={badge.percentage} />
                ) : badge.tipo === "2x1" ? (
                  <BlueTag key={i} />
                ) : (
                  <OfferTag key={i} />
                ),
              )}
            </div>
            {tieneDescuento && (
              <div className="detail-producto-price-wrapper">
                <span className="detail-producto-price-old">
                  {formatMoney(precioOriginal)} CLP
                </span>
              </div>
            )}

            {product.originalPrice && (
              <div className="detail-producto-original-price">
                ${product.producto_precio} CLP
              </div>
            )}

            <p className="detail-producto-description">
              {product.producto_descripcion}
            </p>
            <p className="detail-producto-garantia">
              Ofrecemos una garantía de un año en caso de problemas.
            </p>

            <div className="detail-producto-actions">
              <div className="detail-producto-qty">
                <button onClick={decrease}>–</button>
                <span>{quantity}</span>
                <button onClick={increase}>+</button>
              </div>
              <button
                className="detail-producto-cart-btn"
                onClick={() => handleAddToCart(product)}
              >
                Agregar al carrito
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
};
